//Please add the language resource
const credit = {
  customerNo:'CustomerNo',
  overdueAmount:'OverdueAmount',
  creator:'Creator',
  createTime:'CreateTime',
  overQuota:'OverQuota',
  creditAccount:'CreditAccount',
  accountBank:'AccountBank',
  updater:'Updater',
  updateTime:'UpdateTime',
  bankDeposit:'BankDeposit',
  sevenOverdueAmount:'SevenOverdueAmount',
  amountUsed:'AmountUsed',
  accountName:'AccountName',
  creditName:'CreditName',
  creditLimit:'CreditLimit',
  customerName:'CustomerName',
  msg:{
  }
};
export default credit



// WEBPACK FOOTER //
// ./src/page/finance/credit/lang/credit.en.js